<script lang="ts" setup>
import VModal from '@shared/component/VModal/VModal.vue';
import { nextTick, ref, toRefs, watch } from 'vue';
import { useNotification } from '@shared/plugin/prime-vue/useNotification';
import TextField from '@shared/form/TextField/TextField.vue';
import { usePakketpolisStore } from '../pakketpolisStore';

const props = defineProps<{
  pakketpolisnummer: string;
}>();

const notification = useNotification();

const { pakketpolisnummer } = toRefs(props);

const isOpen = defineModel<boolean>('isOpen');
const extraOpmerking = ref<string>('');
const extraOpmerkingenField = ref<InstanceType<typeof TextField>>();

const pakketpolisStore = usePakketpolisStore();

function opslaan() {
  pakketpolisStore.setExtraOpmerkingen(pakketpolisnummer.value, extraOpmerking.value);
  notification.success('Extra opmerkingen zijn opgeslagen.');
  isOpen.value = false;
}

function reset() {
  const pakketpolis = pakketpolisStore.getPakketpolis(pakketpolisnummer.value);
  extraOpmerking.value = pakketpolis?.extraOpmerkingen ?? '';
}

watch(isOpen, () => {
  if (isOpen.value) {
    nextTick(() => extraOpmerkingenField.value?.focus());
  }
});
</script>

<template>
  <VModal
    overflow
    confirm-button-text="Opmerking opslaan"
    @close-modal="isOpen = false"
    @confirm-action="opslaan"
    @cancel-button-clicked="reset"
    invert-header
    title="Extra opmerking invullen"
    :is-active="isOpen"
  >
    <TextField
      ref="extraOpmerkingenField"
      placeholder="Vul hier uw extra opmerkingen in"
      v-model:value="extraOpmerking"
      :rows="6"
    />
  </VModal>
</template>
